import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isVisible: false,
  message: "",
  data: null,
  actionType: null,
};

const confirmationModalSlice = createSlice({
  name: "confirmationModal",
  initialState,
  reducers: {
    showConfirmationModal: (state, action) => {
      state.isVisible = true;
      state.message = action.payload.message;
      state.data = action.payload.data;
      state.actionType = action.payload.actionType;
    },
    hideConfirmationModal: (state, action) => {
      state.isVisible = false;
      state.message = "";
      state.data = null;
      state.actionType = null;
    },
  },
});

export const { showConfirmationModal, hideConfirmationModal } =
  confirmationModalSlice.actions;

export default confirmationModalSlice.reducer;
